import { Injectable } from '@angular/core';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { DealerSearchRequestModel } from './../business-entities/dealer-search-request-model.interface';
import { Urls } from './../utils/urls';

@Injectable({ providedIn: 'root' })
export class SelectDealerData {
    constructor(private dataService: DataService) { }

    GetAllDealerDetails(model: DealerSearchRequestModel): Promise<GenericResponse<any>> {
        return this.dataService.GetAllwithHeaders<GenericResponse<any>>(Urls.GetAllDealerDetails, model).toPromise();
    }

    GetDealerRentalCars(dealerId: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetDealerRentalCars, dealerId).toPromise();
    }
    GetGenericRentalCars(languageId: string): Promise<GenericResponse<any>> {
      return this.dataService.Get<GenericResponse<any>>(Urls.GetGenericRentalCars, languageId).toPromise();
  }

    GetAdditionalServices(dealerId: string,languageId: string): Promise<GenericResponse<any>> {
        return this.dataService.Get<GenericResponse<any>>(Urls.GetAdditionalServices, dealerId,languageId).toPromise();
    }

  GetCustomerWaitingLimit(model: any): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetCustomerWaitingTime, model).toPromise();
  }
  GetDealerCapacity(model: any): Promise<GenericResponse<any>> {
    return this.dataService.GetAllwithHeaders<GenericResponse<any>>(Urls.GetDealerCapacityDetails, model).toPromise();
  }
  GetMechanicSlots(model: any): Promise<GenericResponse<any>> {
    return this.dataService.GetAllwithHeaders<GenericResponse<any>>(Urls.GetMechanicSlotsDetails, model).toPromise();
  }
  GetSplitMechanicSlots(model: any): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetSplitMechanicSlotsDetails, model).toPromise();
  }
  ReserveSlot(model: any): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.ReserveMechanicSlot, model).toPromise();
  }

  GetServicesByDealerId(dealerId: string, language: string,Brand:string,VehicleType:string,FuelType:string,Mileage:number,VehicleAge:number): Promise<any> {
    return this.dataService.Get<GenericResponse<any>>(Urls.GetServicesByDealerId, dealerId, language,Brand,VehicleType,FuelType,Mileage,VehicleAge).toPromise();
  }

  CheckReserveSlotAvailability(model: any): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.CheckReserveSlotAvailability, model).toPromise();
  }
}
